export default "__VITE_ASSET__$XzsbD$l__"